module.exports = __webpack_public_path__ + "static/media/menuAddressBook.1dfd894f.svg";